import { render, staticRenderFns } from "./ReactivarSolicitud.vue?vue&type=template&id=af33426e"
import script from "./ReactivarSolicitud.vue?vue&type=script&lang=js"
export * from "./ReactivarSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports